import Icons from "../assets/icons/index";

const SelectUserTypeData = [
    {
        id: 1,
        cateCardtitle: "Student",
        cateCardImg: Icons.EducationIcon,
        selectedIcon: Icons.EducationWhiteIcon,
        userType: "College",
        roleValue: "student", // Mapped role value for backend
    },
    {
        id: 2,
        cateCardtitle: "Contractor",
        cateCardImg: Icons.engineerIcon,
        selectedIcon: Icons.engineerWhiteIcon,
        userType: "Company",
        roleValue: "contractor", // Mapped role value for backend
    },
    {
        id: 3,
        cateCardtitle: "Architect",
        cateCardImg: Icons.architectIcon,
        selectedIcon: Icons.architectWhiteIcon,
        userType: "Company",
        roleValue: "architect", // Mapped role value for backend
    },
    {
        id: 4,
        cateCardtitle: "Builder",
        cateCardImg: Icons.builderIcon,
        selectedIcon: Icons.builderWhiteIcon,
        userType: "Company",
        roleValue: "builder", // Mapped role value for backend
    },
    {
        id: 5,
        cateCardtitle: "Consultant",
        cateCardImg: Icons.talkIcon,
        selectedIcon: Icons.talkWhiteIcon,
        userType: "Company",
        roleValue: "consultant", // Mapped role value for backend
    },
    {
        id: 6,
        cateCardtitle: "Government Entity",
        cateCardImg: Icons.governmentIcon,
        selectedIcon: Icons.governmentWhiteIcon,
        userType: "Company",
        roleValue: "government_entity", // Mapped role value for backend
    },
    {
        id: 7,
        cateCardtitle: "Private Entity",
        cateCardImg: Icons.corporationIcon,
        selectedIcon: Icons.corporationWhiteIcon,
        userType: "Company",
        roleValue: "private_entity", // Mapped role value for backend
    },
];

export default SelectUserTypeData;
